import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import { Button, CircularProgress, IconButton, Skeleton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { Input } from 'antd';
import CloseIcon from '@mui/icons-material/Close';

import { Rating } from "@mui/material";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import TextArea from 'antd/es/input/TextArea';

export default function Materials({propsData,tab}) {

  let[categoryMaterials,handleCategoryMaterials]=useState([])
let [errorMaterials,setErrorErrorMaterials]=useState(false)
const location = useLocation()
const [routes,setRoutes]=useState(location.pathname.split("/"))

useEffect(()=>{
  setErrorErrorMaterials(true)
  axios.get(`${process.env.REACT_APP_URL}/api/material/GetAllMaterials`, //proxy uri
  {
     headers: {
        authorization:`Bearer ${ propsData.userData?.token }`,
        'Content-Type': 'application/json'
     } 
  })
  .then(res=>{
    console.log(res.data);
    handleCategoryMaterials(res.data)
    setErrorErrorMaterials(false)
  })
  .catch(error=>{
    console.log(error);
  })
},[propsData.equilizer,location])
let sampleErrorMaterial=[1,2,3,4,5]


  return (
        <div className={`singleCategoryMaterials singleCategoryMaterialsHomePage ${tab&&"singleCategoryMaterialsFullPage"}`}>
           <Link to="/?tab=materials" style={{textDecoration:"none",color:"inherit"}}><h3 style={{textAlign:"center",fontSize:tab&&"25px",marginBottom:tab&&"20px"}}>Materials</h3></Link>
                {!errorMaterials?
                  <div className='singleCategoryMaterialsAll'>
                      {categoryMaterials?.map((e,index)=>{
                            return <EachMaterials propsData={propsData} item={e} key={index}/>
                      })}
                  </div>:
                  <div className='singleCategoryMaterialsAll'>
                       {sampleErrorMaterial.map(e=>{
                        return <Skeleton  variant="rounded"  width={210} height={150}  />
                       })}
                  </div>
                }
          </div>
  )
}

const EachMaterials=({item,propsData})=>{

  let [AveregaRate,HandleAveregaRate]=useState(null)
  useEffect(()=>{
    const sum = item.reviews.reduce((acc, num) => acc + num.rate, 0);
    HandleAveregaRate(sum / item.reviews.length);

  },[item.reviews])
  
  function formatNumberWithCommas(number) {
    // Convert the number to a string
    const numberString = number.toString();
  
    // Split the string into integer and decimal parts (if any)
    const parts = numberString.split('.');
  
    // Format the integer part with commas
    const formattedInteger = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
    // Combine the formatted integer with the decimal part (if any)
    const formattedNumber = parts.length > 1 ? formattedInteger + '.' + parts[1] : formattedInteger;
  
    return formattedNumber;
  }

  let [AddedToCart,HandleAddedToCart]=useState(propsData.userData?.data?.cart?.includes(item?._id))
  let [LoadAddedToCart,HandleLoadAddedToCart]=useState(false)
  let [equilizer,setEquilizer]=useState(0)
  //console.log(propsData.userData?.data?.cart);

  useEffect(()=>{
      axios.get(`${process.env.REACT_APP_URL}/api/user/CheckMaterialInCart/${item._id}`, //proxy uri
      {
        headers: {
            authorization:`Bearer ${ propsData.userData?.token }`,
            'Content-Type': 'application/json'
        } 
      })
      .then(res=>{
      //  console.log(res.data);
        HandleAddedToCart(res.data.msg==="exist"?true:false)
      })
      .catch(error=>{
        console.log(error);
      })

  },[equilizer,item])

  const AddToCart=()=>{
    HandleLoadAddedToCart(true)
    let data={
      materialId:item._id
    }
    axios.put(`${process.env.REACT_APP_URL}/api/user/AddRemoveMaterialCart`,data, //proxy uri
    {
       headers: {
          authorization:`Bearer ${ propsData.userData?.token }`,
          'Content-Type': 'application/json'
       } 
    })
    .then(res=>{
     // console.log(res.data);
     // HandleLoadAddedToCart(false)
       setEquilizer(equilizer+2)
    //  HandleAddedToCart(!AddedToCart)
    })
    .catch(error=>{
     console.log(error);
    })

  }

  return(
    <div 
      className='singleCategoryMaterialsEach singleMaterialMinimized'
      >
               <div className='singleCategoryMaterialsEachImage'>
                    <img src={`${item.images[0].fileUrl}`} width={"100%"} alt={"slider.pic"}/>
                </div>
                <div style={{  padding: "0px 30px 0px 30px"}}>
                    <Link   style={{color:"inherit",textDecoration:"none"}} to={`/materials/${item._id}`}><h3>{item?.name}</h3> </Link>
                    <div className='singleCategoryMaterialsEachImageData'>
                        <div className='singleCategoryMaterialsEachImageDataEachValue'>{formatNumberWithCommas(item.price)}</div>                      
                        <div className="singleCategoryMaterialsEachImageDataRating">
                            <div><Rating name="half-rating-read" value={Math.round(AveregaRate * 10)/10} precision={0.5} readOnly /></div>
                             <div><IconButton onClick={AddToCart}><ShoppingCartIcon style={{color:AddedToCart?"goldenrod":"rgb(100, 60, 0)"}}/></IconButton></div>  
                          </div>

                    </div>
                
                </div>
            
  </div>
  )
}

